<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 2h4v20H5zM15 2h4v20h-4z"/></svg>
</template>